import { clsx } from "clsx";

import { Badge } from "@fronterahealth/frontera-ui-components";

import { GoalStatusEnums } from "@api/graphql/types-and-hooks";
import { getStatusAppearance, getStatusIcon } from "@components/TreatmentPlan/ProgrammingGoalCard/helper";
import { convertReadableString } from "@components/forms/utils";

interface GoalStatusBadgeProps {
  status: string | null | undefined;
  className?: string;
  iconClassName?: string;
}

const GoalStatusBadge: React.FC<GoalStatusBadgeProps> = ({ status, className, iconClassName }) => {
  if (!status) {
    return null;
  }

  const Icon = getStatusIcon(status);
  const appearance = getStatusAppearance(status);

  return (
    <Badge
      className={clsx("h-5 p-1! rounded-xs", className)}
      text={
        <div className={clsx("flex items-center")}>
          <Icon
            className={clsx(
              "w-3  mr-[4px]",
              appearance === "neutral" && "text-text-secondary",
              status === GoalStatusEnums.Inactive ? "h-2.5" : "h-3",
              iconClassName,
            )}
          />
          {convertReadableString(status)}
        </div>
      }
      appearance={appearance}
    />
  );
};

export default GoalStatusBadge;
